import axios from "axios";
import qs from "qs";
import router from "../router";
import GLOBAL from "../../config";

// axios interceptors
// 同一时间有多个请求时，会形成队列。在第一个请求创建loading，在最后一个响应关闭loading
var queue = [];
//当有一个错误弹窗打开时不会再打开第二个
var openWin=false;
axios.interceptors.request.use(
    config => {
        // 显示loading提示
		queue.push(1);
		 
        if (queue.length>0) {
			$root.$store.commit('setShowLoading',true);
        }
       

        // 为请求地址添加全局domain
        if (config.url.indexOf("http://") < 0 || config.url.indexOf("https://") < 0) {
            config.url = GLOBAL.domain + config.url;
        }
        // 设置延迟时效
        config.timeout = GLOBAL.timeout;
        return config;
    },
    error => {
        // 关闭loading提示
        // 继发连续请求，延时处理是为防止多个loading实例闪屏。
        setTimeout(() => {
            queue.shift();
            if (!queue.length){
                $root.$store.commit('setShowLoading',false);
            }
        }, 30);
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    response => {
        // 关闭loading提示
        setTimeout(() => {
            queue.shift();
            if (!queue.length) {
                $root.$store.commit('setShowLoading',false);
            }
        }, 100);
        return response;
    },
    error => {
        // 关闭loading提示
        setTimeout(() => {
            queue.shift();
            if (!queue.length) {
				$root.$store.commit('setShowLoading',false);
            }
        }, 100);
        return Promise.reject(error);
    }
);

const isObject = (v) => {
    return Object.prototype.toString.call(v) === '[object Object]';
}
const global_domain = (v) => {
    return GLOBAL.domain || '';
}
const global_timeout = (v) => {
    return GLOBAL.timeout || 180000;
}

//http request with loading
const http = function(url,params,method,header){
    let p = params!=undefined && params!=null && isObject(params) ? qs.stringify(params) : params;
    if(!header){
        header = {};
    }
    if(!header['Content-Type']){
        header = {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'};
    }
	let requestObj = null;
	if('GET' == method){
		requestObj = {
		    url: url,
		    method: method,
			params:params,
		    headers: header
		};
	}
	else{
		requestObj = {
			 url: url,
			 method: method,
			 data: p,
			 headers: header
		};
	}
    return new Promise((resolve, reject) => {
        axios(requestObj).then((res) => {
            if(res.data.code == 0){
                resolve(res.data);
            }
            else{
                let content="";
                if(res.data.code == -100){//未登录
                    content="系统检测到您尚未登录，请先登录";
					$root.$cookies.remove("_xunw_admin_logined");
                    if(!openWin){
                        openWin = true;
						$root.$confirm(content,
							()=>{
								 router.push({ name: "Login" });
								 openWin = false;
							},
							()=>{
								openWin = false;
							}
						);
                    }
                }
                else if(res.data.code == -99){//账号被占用
                    content="您的账号在别处登录，当前登录状态失效，请检查账号密码安全性或者重新登录。";
					$root.$cookies.remove("_xunw_admin_logined");
                    if(!openWin){
                        openWin = true;
						$root.$confirm(content,
							()=>{
								 router.push({ name: "Login" });
								 openWin = false;
							},
							()=>{
								openWin = false;
							}
						);
                    }
                }
                else{
                    content = res.data.message;
                    if(!openWin){
                        openWin = true;
						$root.$error(content,()=>{
							openWin = false;
						});
                    }
                }
                reject(res.data);
            }
        }).catch(function (error) {
            if(!openWin){
                openWin = true;
				$root.$error('服务响应异常'+error,()=>{
					openWin = false;
				});
            }
            reject(error);
        });
    })
};

//http request without loading
const http_silent = function(url,params,method,header){
    let p = params!=undefined && params!=null && isObject(params) ? qs.stringify(params) : params;
    if(!header){
        header = {};
    }
    if(!header['Content-Type']){
        header = {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'};
    }
    if (url.indexOf("http://") < 0 || url.indexOf("https://") < 0) {
    	url = global_domain() + url;
    }
    let timeout = global_timeout();
    let axiosSilentInstance = axios.create();
	let requestObj = null;
	if('GET' == method){
		requestObj = {
		    url: url,
		    method: method,
			params:params,
		    headers: header,
			timeout:timeout
		};
	}
	else{
		requestObj = {
			url: url,
			method: method,
			data: p,
			headers: header,
			timeout:timeout
		};
	}
    return new Promise((resolve, reject) => {
    	axiosSilentInstance(requestObj).then((res) => {
            if(res.data.code == 0){
                resolve(res.data);
            }
            else{
                let content="";
                if(res.data.code == -100){//未登录
                    content="系统检测到您尚未登录,请登录";
					$root.$cookies.remove("_xunw_admin_logined");
                    if(!openWin){
                        openWin = true;
						$root.$confirm(content,
							()=>{
								 router.push({ name: "Login" });
								 openWin = false;
							},
							()=>{
								openWin = false;
							}
						);
                    }
                }
                else if(res.data.code == -99){//账号被占用
                    content="您的账号在别处登录，当前登录状态失效，请检查账号密码安全性或者重新登录。";
					$root.$cookies.remove("_xunw_admin_logined");
                    if(!openWin){
                       openWin = true;
                       $root.$confirm(content,
                       	()=>{
                       		 router.push({ name: "Login" });
                       		 openWin = false;
                       	},
                       	()=>{
                       		openWin = false;
                       	}
                       );

                    }
                }
                else{
                    content = res.data.message;
                    if(!openWin){
                        openWin = true;
						$root.$error(content,()=>{
							openWin = false;
						});
                    }
                }
                reject(res.data);
            }
        }).catch(function (error) {
            if(!openWin){
                openWin = true;
				$root.$error('服务响应异常'+error,()=>{
					openWin = false;
				});
            }
            reject(error);
        });
    })
};


export default {
    get:function(url,params,header){
        return http(url,params,"GET",header);
    },
    post:function(url,params,header){
        return http(url,params,"POST",header);
    },
    get_s:function(url,params,header){//不带loading效果的请求
        return http_silent(url,params,"GET",header);
    },
    post_s:function(url,params,header){//不带loading效果的请求
        return http_silent(url,params,"POST",header);
    }
}

